module.exports = __webpack_public_path__ + "static/media/user-edit.1a532c52.svg";